// Classifies the number typed in an intl-tel-input (v19) field against the
// country selected in its flag selector, using the library's libphonenumber
// metadata rather than per-country digit counts.
//
// Returns null when the number is acceptable, or when it cannot be judged yet
// (blank, or utils.js not loaded — the server-side check stays the fallback).
// Otherwise returns 'too_short', 'too_long' or 'invalid'.
//
// iti.isValidNumber() is NOT used: in v19 it only checks the length
// (libphonenumber isPossibleNumber), so a number with the right digit count
// but an impossible structure would pass. isValidNumberPrecise() checks both.
export function phoneValidationError (iti, value) {
  if (!value || !value.trim()) return null

  const valid = iti.isValidNumberPrecise()
  if (valid === null || valid) return null

  const { TOO_SHORT, TOO_LONG, IS_POSSIBLE_LOCAL_ONLY } = window.intlTelInputUtils.validationError

  switch (iti.getValidationError()) {
    case TOO_SHORT:
    case IS_POSSIBLE_LOCAL_ONLY:
      return 'too_short'
    case TOO_LONG:
      return 'too_long'
    default:
      return 'invalid'
  }
}
